module.exports = __webpack_public_path__ + "img/co-branding-logos-secondary.dc64b750.gif";